var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBattery00Icon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 19H40V17C40 16.2044 39.6839 15.4413 39.1213 14.8787C38.5587 14.3161 37.7956 14 37 14H7C6.20435 14 5.44129 14.3161 4.87868 14.8787C4.31607 15.4413 4 16.2044 4 17V31C4 31.7956 4.31607 32.5587 4.87868 33.1213C5.44129 33.6839 6.20435 34 7 34H37C37.7956 34 38.5587 33.6839 39.1213 33.1213C39.6839 32.5587 40 31.7956 40 31V29H44V19ZM38 31C38 31.2652 37.8946 31.5196 37.7071 31.7071C37.5196 31.8946 37.2652 32 37 32H7C6.73478 32 6.48043 31.8946 6.29289 31.7071C6.10536 31.5196 6 31.2652 6 31V17C6 16.7348 6.10536 16.4804 6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16H37C37.2652 16 37.5196 16.1054 37.7071 16.2929C37.8946 16.4804 38 16.7348 38 17V31Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBattery00Icon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Battery00_icon.26171b4ebb25a2dd67590740e48ea5bf.svg";